export const ONE_MINUTES = 60000
export const TWO_MINUTES = 120000
export const THREE_MINUTES = 180000
export const ONE_HOUR = 3600000
export const THREE_HOUR = ONE_HOUR * 3
